import { PaymentsRounded } from "@mui/icons-material";
import { CircularProgress, Paper, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../App";

const PaymentWidget = ({ invs = [] }) => {
  const { t } = useTranslation();
  const { branch } = useContext(AppContext);
  const [total, setTotal] = useState(0);
  const [paid, setPaid] = useState(0);
  const [overdue, setOverdue] = useState(0);
  const [due, setDue] = useState(0);
  const [currency, setCurrency] = useState("");

  useEffect(() => {
    branch && setCurrency(branch.currency);
    return () => {};
  }, [branch]);

  useEffect(() => {
    setTotal(invs.map((j) => j.amount).reduce((x, y) => x + y, 0));
    setOverdue(
      invs
        .filter((j) => new Date(j.dueDate) < new Date())
        .map((j) => j.amount - j.paidAmt)
        .reduce((x, y) => x + y, 0)
    );
    setPaid(invs.map((j) => j.paidAmt).reduce((x, y) => x + y, 0));
    setDue(
      invs
        .filter((j) => new Date(j.dueDate) > new Date())
        .map((j) => j.amount - j.paidAmt)
        .reduce((x, y) => x + y, 0)
    );
    return () => {};
  }, [invs]);

  return (
    <Paper sx={{ padding: { xs: "10px", md: "15px" } }}>
      <h2 className="fs-18 tx-upp gray-color fw-4 m-0 d-flex">
        <PaymentsRounded color="primary" /> &nbsp;&nbsp;{" "}
        {t("PaymentsThisMonth")}
      </h2>
      <div className="d-flex flex-wrap g-10 j-evenly">
        <div className="tx-center">
          <div className="mt-40 mb-10 tx-center pos-relative">
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div>
                <Typography
                  variant="span"
                  className="mb-5 dark-color fw-5 gray-color"
                >
                  {currency + " " + due.toLocaleString()}
                </Typography>
                <Typography
                  className="grayMD-color"
                  sx={{ fontSize: { xs: "12px", md: "14px" } }}
                >
                  / {currency + " " + total.toLocaleString()}
                </Typography>
              </div>
            </div>
            <CircularProgress
              variant="determinate"
              value={100}
              thickness={2}
              sx={{
                position: "absolute",
                color: "var(--grayXS-color)",
                height: { xs: "90px !important", md: "150px !important" },
                width: { xs: "90px !important", md: "150px !important" },
              }}
            />
            <CircularProgress
              variant="determinate"
              value={(due / total) * 100 || 0}
              size="100%"
              thickness={2}
              sx={{
                strokeLinecap: "round",
                height: { xs: "90px !important", md: "150px !important" },
                width: { xs: "90px !important", md: "150px !important" },
              }}
            />
          </div>
          <span className="gray-color"> {t("Scheduled")}</span>
        </div>
        <div className="tx-center">
          <div className="mt-40 mb-10 tx-center pos-relative">
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div>
                <Typography
                  variant="span"
                  className="mb-5 dark-color fw-5 gray-color"
                >
                  {currency + " " + paid.toLocaleString()}
                </Typography>
                <Typography
                  className="grayMD-color"
                  sx={{ fontSize: { xs: "12px", md: "14px" } }}
                >
                  / {currency + " " + total.toLocaleString()}
                </Typography>
              </div>
            </div>
            <CircularProgress
              variant="determinate"
              value={100}
              thickness={2}
              sx={{
                position: "absolute",
                color: "var(--grayXS-color)",
                height: { xs: "90px !important", md: "150px !important" },
                width: { xs: "90px !important", md: "150px !important" },
              }}
            />
            <CircularProgress
              variant="determinate"
              value={paid}
              size="100%"
              thickness={2}
              color="success"
              sx={{
                strokeLinecap: "round",
                height: { xs: "90px !important", md: "150px !important" },
                width: { xs: "90px !important", md: "150px !important" },
              }}
            />
          </div>
          <span className="gray-color">{t("Paid")}</span>
        </div>
        <div className="tx-center">
          <div className="mt-40 mb-10 tx-center pos-relative">
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div>
                <Typography
                  variant="span"
                  className="mb-5 dark-color fw-5 gray-color"
                >
                  {currency + " " + overdue.toLocaleString()}
                </Typography>
                <Typography
                  className="grayMD-color"
                  sx={{ fontSize: { xs: "12px", md: "14px" } }}
                >
                  / {currency + " " + total.toLocaleString()}
                </Typography>
              </div>
            </div>
            <CircularProgress
              variant="determinate"
              value={100}
              thickness={2}
              sx={{
                position: "absolute",
                color: "var(--grayXS-color)",
                height: { xs: "90px !important", md: "150px !important" },
                width: { xs: "90px !important", md: "150px !important" },
              }}
            />
            <CircularProgress
              variant="determinate"
              value={(overdue / total) * 100 || 0}
              size="100%"
              thickness={2}
              color="error"
              sx={{
                strokeLinecap: "round",
                height: { xs: "90px !important", md: "150px !important" },
                width: { xs: "90px !important", md: "150px !important" },
              }}
            />
          </div>
          <span className="gray-color">{t("Overdue")}</span>
        </div>
      </div>
    </Paper>
  );
};

export default PaymentWidget;
